<template>
  <div class='BtnLike'>
    <to-like @click="push" v-if="!liked"/>
    <go-like v-if="liked"/>
  </div>
</template>

<script>
import ToLike from './ToLike'
import GoLike from './GoLike'
export default {
  name: 'BtnLike',
  components: { ToLike, GoLike },
  props: ['data'],
  data () {
    return {
      liked: false
    }
  },
  methods: {
    async push () {
      let likes = JSON.parse(localStorage.getItem('likes'))
      if(likes) {
        likes.push(this.data)
        localStorage.setItem('likes', JSON.stringify(likes))
      }
      else {
        localStorage.setItem('likes', JSON.stringify([this.data]))
      }
      this.liked = true
    }
  },
  created () {
    let likes = JSON.parse(localStorage.getItem('likes'))
    if(likes) {
      if(likes.filter(i => i.id === this.data.id).length) {
        this.liked = true
      }
    }
    else {
      this.liked = false
    }
  }
}
</script>

<style scoped>
.BtnLike {
  padding-top: 5%;
}

@media (max-width: 500px) {
  .BtnLike {
    display: flex;
    justify-content: center;
  } 
}
</style>
